import NrwUiBlank from '~pages/nrw/layouts/NrwUiBlank.vue'

export default {
  content: NrwUiBlank
}



// WEBPACK FOOTER //
// ./src/components/pages/nrw/layouts/NrwSingleLayoutComponents.js